import { BRAND } from "../../../constants/brand";
import React from "react";
import { Button, Row, Col, Card } from "antd";
import ButtonComponent from "../../../components/common/button";
import styles from "./UnfollowSeries.module.scss";
import bannerImage3 from "../../../assets/originbg.png";

const books = [
  {
    title: "The Dark Side of Food",
    img: "/Images/darkfood.png",
    alt: "Dark Side of Food",
    button: {
      type: "image",
      src: "/Images/beat.png",
      alt: "The Beat",
    },
  },
  {
    title: "The Dark Side of Fashion",
    img: "/Images/darkfashion.png",
    alt: "Dark Side of Fashion",
    button: {
      type: "image",
      src: "/Images/payrus.png",
      alt: "Papyrus",
    },
  },
  {
    title: "The Dark Side of Energy",
    img: "/Images/darkenergy.png",
    alt: "Dark Side of Energy",
    button: {
      type: "comingSoon",
      label: "Coming Soon",
    },
  },
  {
    title: "The Dark Side of Love",
    img: "/Images/darkLove.png",
    alt: "Dark Side of Love",
    button: {
      type: "comingSoon",
      label: "Coming Soon",
    },
  },
];

const UnfollowSeries = () => {
  return (
    <div
      className={styles.unfollowSection}
      style={{
        background: `url(${bannerImage3}) no-repeat top center/cover`,
      }}
    >
      <h2>
        The <span className={styles.highlight}>UNFOLLOW</span> Series
      </h2>
      <p className={styles.description}>
        Read {BRAND.domainLabel}&apos;s origin story in The UNFOLLOW Series of graphic
        novels, which raise awareness on the dangers posed by the current social
        media model that exploits young people. The books use a fictional
        narrative to raise awareness on the abuse of power and misinformation by
        influencers, advertisers and algorithms online.
      </p>
      <div className={styles.buttons}>
        <a
          href="https://www.thebuddyhood.com/the-unfollow-series"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ButtonComponent
            {...{
              type: "primary",
              text: "Find Out More",
              variant: "gold",
            }}
          />
        </a>
        <a
          href="https://www.thebuddyhood.com/shop"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ButtonComponent
            {...{
              type: "primary",
              text: "Buy Now",
              variant: "black",
            }}
          />
        </a>
      </div>
      <Row gutter={[16, 24]} justify="center" className={styles.cardRow}>
        {books.map((book, index) => (
          <Col xs={24} sm={12} md={6} key={index}>
            <Card
              cover={
                <img
                  alt={book.alt}
                  src={book.img}
                  className={styles.bookImage}
                />
              }
              bordered={false}
              className={styles.bookCard}
            >
              {book.button.type === "image" ? (
                <Button className={styles.vendorBtn}>
                  <img
                    src={book.button.src}
                    alt={book.button.alt}
                    className={styles.vendorLogo}
                  />
                </Button>
              ) : (
                <Button className={styles.disabledBtn} disabled>
                  {book.button.label}
                </Button>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default UnfollowSeries;
